import { Directive, ElementRef, HostListener, Input } from '@angular/core';

import { AppState } from 'src/app/app.state';
import { ClientConfigurationState } from '../client-configuration/client-configuration.state';
import { Store } from '@ngrx/store';
import { routeTo } from './routing.actions';
import { selectClientConfiguration } from '../client-configuration/client-configuration.selectors';
import { take } from 'rxjs/operators';

@Directive({
	selector: '[ahpRouteTo]',
})
export class RouteToDirective {
	isAnchor: boolean;
	parts: string[];
	tenant: string;
	merchantId: string;
	language: string;

	constructor(private store: Store<AppState>, private element: ElementRef) {
		this.isAnchor = element.nativeElement.nodeName === 'A';

		store
			.select(selectClientConfiguration)
			.pipe(take(1))
			.subscribe((client: ClientConfigurationState) => {
				this.tenant = client.tenantName;
				this.merchantId = client.merchantId;
				this.language = client.language;
			});
	}

	@Input()
	set ahpRouteTo(route: string) {
		const { nativeElement } = this.element;

		// Remove starting / if someone accidentally adds it.
		this.parts = (route.charAt(0) === '/' ? route.slice(1) : route).split('/');

		if (this.isAnchor) {
			nativeElement.href = '/' + [this.tenant, this.merchantId, this.language].concat(this.parts).join('/');
		} else {
			nativeElement.role = 'button';
			nativeElement.classList.add('cursor--pointer');
		}
	}

	@HostListener('click', ['$event'])
	onClick(event: MouseEvent) {
		if (this.isAnchor) {
			event.preventDefault();
		}
		this.store.dispatch(routeTo({ payload: [...this.parts] }));
		return false;
	}
}
